import { render } from "./TransferWarranty.vue?vue&type=template&id=5e0356b5"
const script = {}
script.render = render

export default script